import { defineStore } from "pinia"

export const useSnackbarStore = defineStore("snackbar", {
  state: () => ({
    snack: {
      text: null,
      show: false,
      time: 5000,
      type: "info",
      autoclose: true,
    },
  }),
  actions: {
    startTimer() {
      if (this.snack.autoclose) {
        const self = this
        setTimeout(() => {
          self.close()
        }, this.snack.time)
      }
    },
    snack(options) {
      if (options && options.e) {
        if (options.e.response) {
          console.log("SNACK ERROR", options.e.response.status)
          if (
            options.e.response.status === 403 ||
            options.e.response.status === "403"
          ) {
            // dispatch('users/setUserProfile', options.e.response.data, { root: true })
            this.snack = {
              text: "Your profile is locked. please contact for support.",
              type: "error",
              show: true,
              autoclose: true,
            }
            return
          }
          if (options.e.response.status === 401) {
            // dispatch('users/logout', null, { root: true })
          } else if (options.e.response.status === 422) {
            if (options.e.response.data.errors) {
              this.snack = {
                text: options.e.response.data.errors[
                  Object.keys(options.e.response.data.errors)[0]
                ][0],
                type: "error",
                show: true,
                autoclose: true,
              }
            } else {
              this.snack = {
                text: "Please add all required data",
                type: "error",
                show: true,
                autoclose: true,
              }
            }
            this.startTimer()
          } else if (options.e.response.status === 404) {
            this.snack = {
              text: options.e.response.data.message,
              type: "error",
              show: true,
              autoclose: true,
            }
            this.startTimer()
          } else if (options.e.response.message) {
            this.snack = {
              text: options.e.response.data.message,
              type: "error",
              show: true,
              autoclose: true,
            }
            this.startTimer()
          } else {
            this.snack = {
              text: "An error occurred. Please contact support if it remains",
              type: "error",
              show: true,
              autoclose: true,
            }
            this.startTimer()
          }
        } else {
          if (options.e.toString().indexOf("401") > -1) {
            // dispatch('users/logout', null, { root: true })
            this.startTimer()
            return
          }
          if (options.e.toString().indexOf("422") > -1) {
            this.snack = {
              text: "Please add all required data",
              type: "error",
              show: true,
              autoclose: true,
            }
            this.startTimer()
            return
          }

          if (options.e.toString().indexOf("404") > -1) {
            this.snack = {
              text: options.e.response.data.message,
              type: "error",
              show: true,
              autoclose: true,
            }
            this.startTimer()
            return
          }
        }

        console.log(options)

        // this.snack = { text: 'An error occurred. Please contact support if it remains', type: 'error', show: true, autoclose: true }
        this.startTimer()
        return
      }

      this.snack = { ...this.snack, ...options }

      this.startTimer()
    },
    close() {
      this.snack.show = false
      this.snack = { ...this.snack }
    },
  },
})
